// recoil
import { atom } from 'recoil';

function readFilterFromLS(key) {
    try {
        const raw = localStorage.getItem(process.env.LOCAL_STORAGE_NAME);
        return JSON.parse(raw)?.filter?.[key] ?? [];
    } catch {
        return [];
    }
}

const TransientDefault = {
    filter: {
        search: { data: [], selected: readFilterFromLS('search') },
        trending: { data: [], selected: readFilterFromLS('trending') },
        recommend: { data: [], selected: readFilterFromLS('recommend') },
        explore: { data: [], selected: readFilterFromLS('explore') },
        option: { data: [] },
    },
    internal: {
        error: '',
        warning: '',
        info: '',
        success: '',
        mute: true,
        blocked: null,
        inactive: false,
        loginPrompt: false,
    },
    main: {
        containers: [],
        stack: null,
        notice: [],
    },
    opensource: {
        infra: [],
        npm: [],
    },
    path: {
        gateway: 'login',
        main: 'home',
        second: '/',
        profile: '/',
        settingAccount: '/',
    },
    signup: {
        email: '',
    },
    // logged-in user (null = guest), the `user` of the server isauth response
    user: null,
    // user: {
    //     _id, username, email, services,
    //     image, thumbnail, imageStatus,   // profile image + moderation state
    //     status, type, badges, subscription, location, createdAt, loginAt,
    // }
    // the logged-in user's own profile numbers the client keeps counting (request-control/own-counts.js)
    profile: {
        followingCount: null,
        favoritesCount: null,
    },
};

const TransientState = atom({
    key: 'TransientState',
    default: TransientDefault,
});

export { TransientState };
